const TravelingParticlesShader = {
    vertexShader: /* glsl */ `
      precision highp float;
      precision highp int;
    
      varying vec2 vUv;
      varying vec3 vPosition;
      varying float vOpacity;
      varying vec3 vColor;
      varying float vRotation;
      varying float vLineLength;
      attribute float opacity;
      attribute vec3 aColor;
      attribute float aRotation;
      attribute float aPointSize;
      attribute float aLineLength;
      uniform float uPointSize;
      float PI = 3.141592653589793238;
      
      void main() {
        vUv = uv;
        vOpacity = opacity;
        vec4 mvPosition = modelViewMatrix * vec4( position, 1. );
         /**
           * TODO particle point intensity 
           * 
           */
        gl_Position = projectionMatrix * mvPosition;
        gl_PointSize = clamp((1. / -mvPosition.z) * uPointSize * aPointSize, 1.0, 64.0);
        vColor = aColor;
        vRotation = aRotation;
        vLineLength = aLineLength;
      }  
    `,
  
    fragmentShader: /* glsl */ `
      precision highp float;
      precision highp int;

      uniform float uOpacity;
      uniform sampler2D texture1;
      uniform vec3 uColor;
      varying vec3 vColor;
      varying vec2 vUv;
      varying float vOpacity;
      varying float vRotation;
      uniform float uLineLength;
      uniform float uLineThickness;
      varying float vLineLength;
      
      float PI = 3.141592653589793238;

      float sdSegmentRounded( in vec2 p, in vec2 a, in vec2 b, in float r)
      {
          vec2 pa = p-a, ba = b-a;
          float h = clamp( dot(pa,ba)/dot(ba,ba), 0.0, 1.0 );
          return length( pa - ba*h ) - r;
      }

      mat2 rotate2d(float _angle){
        return mat2(cos(_angle),-sin(_angle),
                    sin(_angle),cos(_angle));
    }

      float sdOrientedBoxRounded( in vec2 p, in vec2 a, in vec2 b, float th, in float r)
      {
          float l = length(b-a);
          vec2  d = (b-a)/l;
          vec2  q = (p-(a+b)*0.5);
                q = mat2(d.x,-d.y,d.y,d.x)*q;
                q = abs(q)-vec2(l,th)*0.5;
          return length(max(q,0.0)) + min(max(q.x,q.y),0.0) - r;    
      }
        void main() {
          vec2 uv = vec2(gl_PointCoord.x,1. - gl_PointCoord.y);
          vec2 cUV = 2.*uv - 1.;
            
          mat2 rotation = rotate2d(vRotation);
          vec4 color = vec4(sdOrientedBoxRounded(rotation * cUV, vec2(0.0, (-uLineLength + uLineThickness) * vLineLength), vec2(0.0, (uLineLength - uLineThickness) * vLineLength), uLineThickness, uLineThickness));
          color = smoothstep(uLineThickness, 0.0, color);
          color.rgb *= vColor;
          color.a *= vOpacity;
      
          //color.a = min(1.,color.a)*10.;
          color.a *= uOpacity;
            
          gl_FragColor = vec4(color.rgb, color.a);
        }

     

    `,
  };
  
  export default TravelingParticlesShader;
  